import { apiCredSystemInvoices } from '~/credsystem/services/apiCredSystem';

interface APIResponse {
  titular: string;
  numeroCartao: string;
  nascimento: string;
  vencimento?: string;
  situacaoCartao: string;
  isHabilitadoCompra: boolean;
  Limite: {
    Global: {
      Disponivel: number;
      Estipulado: number;
    };
  };
}

export async function GetCredsystemCardInfoUseCase(): Promise<APIResponse> {
  const response = await apiCredSystemInvoices.get<APIResponse>(
    `/cartao/api/v1/titular`
  );

  return response?.data;
}
